<template>
  <main id="app">
    <Header/>

    <b-container>
      <transition name="slide" mode="out-in">
        <router-view></router-view>
      </transition>

      <notifications position="top right" group="notification" class="my-4 mx-4"/>
    </b-container>

    <b-modal ref="cookies-modal" v-bind:title="$t('cookies_policy.cookies_preferences')" modal-class="cookies-modal" hide-footer centered>
      <p>{{ $t('cookies_policy.header') }}</p>
      <div>
        <p v-on:click=toggleShowHideCookiesPolicy() class="cookies-policy-button font-bold">
          {{ $t('cookies_policy.policy') }}
        </p>
      </div>
      <div v-show="showingCookiesPolicy">
        <span class="font-bold">
          {{ $t('cookies_policy.info_1_header') }}
        </span>
        <p>
          {{ $t('cookies_policy.info_1_text') }}
        </p>
        <span class="font-bold">
          {{ $t('cookies_policy.info_2_header') }}
        </span>
        <p>
          {{ $t('cookies_policy.info_2_text') }}
        </p>
      </div>
      <div class="mt-4 flex flex-justify-center flex-align-center">
        <b-button @click="hideCookiesModal">
          {{ $t('cookies_policy.accept_cookies') }}
        </b-button>
      </div>
    </b-modal>

    <Footer/>
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Header from './components/Header'
import Footer from './components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState(['language', 'showCookiesPolicy']),
  },
  watch: {
    'language': {
      handler() {
        if (this.language && this.$i18n) {
          this.$i18n.locale = this.language;
        }
      },
    },
  },
  data() {
    return {
      showingCookiesPolicy: false,
    }
  },
  mounted() {
    this.showCookiesModal();
  },
  methods: {
    ...mapActions(['setStateShowCookiesPolicy']),
    toggleShowHideCookiesPolicy() {
      this.showingCookiesPolicy = !this.showingCookiesPolicy;
    },
    showCookiesModal() {
      if (this.showCookiesPolicy) {
        this.$refs['cookies-modal'].show();
      }
    },
    hideCookiesModal() {
      this.$refs['cookies-modal'].hide();
      this.setStateShowCookiesPolicy(false);
    },
  }
}
</script>

<style>
#app {
  width: auto;
  height: 100vh;
  background-color: #fff;
  font-style: normal;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.navbar  {
  background-color: #efefef;
}

.cookies-modal .modal-content {
  position: absolute !important;
  bottom: 0px !important;
}

.cookies-policy-button {
  cursor: pointer;
}

.font-bold {
  font-weight: bold;
}

@keyframes slide-in {
  from {
    transform: translateX(-25px);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateX(+25px);
    opacity: 0;
  }
}

@keyframes slide-up {
  from {
    transform: translateY(+50px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes slide-down {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

.justify-content-60 {
  width: 60%;
  text-align: justify;
}

.slide-enter-active {
  animation: slide-in 0.25s ease;
}

.slide-leave-active {
  animation: slide-out 0.25s ease;
}

.full-height {
  height: 100%;
  width: auto;
}

.flex {
  display: flex;
}

.flex-justify-center {
  justify-content: center;
}

.flex-justify-start {
  justify-content: flex-start;
}

.flex-justify-end {
  justify-content: flex-end;
}

.flex-align-center {
  align-items: center;
}

.flex-align-start {
  align-items: flex-start;
}

.flex-align-end {
  align-items: flex-end;
}

.flex-space-between {
  justify-content: space-between;
}

.flex-space-around {
  justify-content: space-around;
}

.flex-start {
  justify-content: flex-start;
}

.flex-end {
  justify-content: flex-end;
}

.flex-row {
  flex-direction: row;
}

.flex-column {
  flex-direction: column;
}

@media only screen and (max-width: 991px) {
  .justify-content-60 {
    width: 100%;
  }
}
</style>

